<template>
    <div v-if="profile" class="employee-details">

        <div v-if="!profile.fullName" class="text-center">
            <loading-icon></loading-icon>
        </div>

        <div v-else class="row">
            <div class="col-12">

                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12">
                                <ul>
                                    <li><span class="key">Your Name:</span><span class="value">
                                        {{ profile.fullName }}</span></li>
                                    <li><span class="key">Mobile Phone:</span><span class="value">
                                        {{ profile.mobile }}</span></li>
                                    <li><span class="key">Tax Band</span><span class="value">
                                        {{ profile.incomeTaxBand.ratePercent }}%</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="card details">
                            <h3>Main Driver / Employee</h3>
                            <ul>
                                <li><span class="key">Name: </span><span class="value">{{ profile.fullName }}</span></li>
                                <li><span class="key">Driver Email: </span><span class="value">{{ profile.emailAddress }}</span></li>
                                <li v-if="showMainDriverDrivingLicense"><span class="key">Driving Licence Number: </span><span class="value">{{ profile.driverLicence.licenceNumber }}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row" v-for="additionalDriver, index in additionalDrivers">
                    <div class="col-12">
                        <div class="card details">
                            <h3>Additional Driver {{ index + 1 }}</h3>
                            <ul>
                                <li><span class="key">Name: </span><span class="value">{{ additionalDriver.first_name }} {{ additionalDriver.last_name }}</span></li>
                                <li><span class="key">Driver Email: </span><span class="value">{{ additionalDriver.email }}</span></li>
                                <li v-if="(index === 0 && showAdditionalDriver1DrivingLicense) || (index === 1 && showAdditionalDriver2DrivingLicense)"><span class="key">Driving Licence Number: </span><span class="value">{{ additionalDriver.driving_license }}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-12">
                        <div class="agree mb-0">
                            <input type="checkbox" name="disclaimer_1" id="disclaimer_1"
                                v-model="employeeDetails" class="disclaimer_1">
                            <label for="disclaimer_1">{{ declaration }}</label>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
  <div v-else class="my-5 text-center">
    <LoadingIcon/>
  </div>

</template>

<script>
import LoadingIcon from "@/components/loading-icon.vue";
export default {
    name: 'bch-driver-profile',
    components: { LoadingIcon },

    props: ['profile', 'session', 'declaration', 'additionalDrivers', 'adminPortalData'],

    data: () => {
        return {
            employeeDetails: null,
        }
    },
    watch: {
        employeeDetails(value) {
            this.$parent.confirmations.employeeDetails = value;
        },
    },
    computed: {
        showMainDriverDrivingLicense() {
            return this.adminPortalData?.content?.products?.bch[0].display_settings_show_driving_license_main_driver;
        },

        showAdditionalDriver1DrivingLicense() {
            return this.adminPortalData?.content?.products?.bch[0].display_settings_show_driving_license_additional_driver_1;
        },

        showAdditionalDriver2DrivingLicense() {
            return this.adminPortalData?.content?.products?.bch[0].display_settings_show_driving_license_additional_driver_2;
        },
        privateCarMileageReimbursementRate() {
            if (!this.session?.driverProfile?.PCH) {
                return '';
            }
            return this.session.driverProfile.PCH.driverGradeDefinition.businessFuelPolicyName;
        },
        privateCarMileageReimbursementRateUpTo() {
            if (!this.session?.driverProfile?.PCH) {
                return '';
            }
            let fuelRate = '';
            this.session.driverProfile.PCH.driverGradeDefinition.businessFuelRates[0].items.forEach((item) => {
                if (Number(item.upToDistance) <= 10000) {
                    fuelRate = (item.fuelRate * 100) + ' ppm';
                }
            });

            return fuelRate;
        },
        privateCarMileageReimbursementRateOver() {
            let maxDistance = 0;
            let maxFuelRate = '';

            if (!this.session?.driverProfile?.PCH) {
                return '';
            }

            this.session.driverProfile.PCH.driverGradeDefinition.businessFuelRates[0].items.forEach((item) => {
                if (Number(item.upToDistance) > 10000 && Number(item.upToDistance) > maxDistance) {
                    maxDistance = item.upToDistance;
                    maxFuelRate = (item.fuelRate * 100) + ' ppm';
                }
            });
            return maxFuelRate;
        }
    }
};
</script>
